import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Asset, Quote } from '@zero/shared/util-models';
import { DiscoverArticleVM } from '../entities/discover-article.entity';
import { DiscoverIndexVM } from '../entities/discover-index.entity';
import { DiscoverInstrumentVM } from '../entities/discover-instrument.entity';
import { DiscoverListAndLinksDetailsVM } from '../entities/discover-lists-and-links.entity';
import { DiscoverOverviewVM } from '../entities/discover-overview.entity';
import { DiscoverTopPerformerInstrumentVM } from '../entities/discover-top-performer-instrument.entity';
import { MultiOrderStrategiesOverviewType, MultiOrderStrategy, MultiOrderStrategyDetails } from '../entities/multi-order-strategy.entity';

export const discoverActions = createActionGroup({
  source: 'Discover',
  events: {
    'Set Overview Loading': props<{ loading: boolean }>(),
    'Load Discover Overview': props<{ force: boolean }>(),
    'Subscribe To Indices': emptyProps(),
    'Subscribe To Indices Failure': emptyProps(),
    'Unsubscribe From Indices': emptyProps(),
    'Update Indices Quotes': props<{ indices: DiscoverIndexVM[] }>(),
    'Load Discover Today Details': props<{ id: string }>(),
    'Load Discover Megatrends Details': props<{ id: string }>(),
    'Load Discover Know How Details': props<{ id: string }>(),
    'Load Discover List Details': props<{ id: string }>(),
    'Clear Discover Details': emptyProps(),
    'Subscribe To Details Instruments': emptyProps(),
    'Subscribe To Details Instruments Failure': emptyProps(),
    'Unsubscribe From Details Instruments': emptyProps(),
    'Update Details Instruments Quotes': props<{ instruments: DiscoverInstrumentVM[] }>(),
    'Subscribe To List Instruments': emptyProps(),
    'Subscribe To List Instruments Failure': emptyProps(),
    'Unsubscribe From List Instruments': emptyProps(),
    'Update List Instruments Quotes': props<{ instruments: DiscoverInstrumentVM[] }>(),
    'Subscribe To Top Performer Instruments': props<{ groupIdentifier: string }>(),
    'Subscribe To Top Performer Instruments Failure': emptyProps(),
    'Unsubscribe From Top Performer Instruments': props<{ groupIdentifier: string }>(),
    'Update Top Performer Instruments Quotes': props<{ instruments: DiscoverTopPerformerInstrumentVM[] }>(),
    'Load Multi Order Strategies': props<{ strategyType: MultiOrderStrategiesOverviewType }>(),
    'Load Multi Order Strategy': props<{ id: string }>(),
    'Update Multi Order Strategy Asset Quotes': props<{ quotes: Record<string, Quote> }>(),
    'Clear Multi Order Strategy': emptyProps(),
    'Clear Multi Order Strategies': emptyProps(),
  },
});

export const discoverApiActions = createActionGroup({
  source: 'Discover API',
  events: {
    'Load Discover Overview Success': props<{ overview: DiscoverOverviewVM }>(),
    'Load Discover Overview Failure': props<{ error: HttpErrorResponse }>(),
    'Load Discover Article Details Success': props<{ details: DiscoverArticleVM }>(),
    'Load Discover Article Details Failure': props<{ error: HttpErrorResponse }>(),
    'Load Discover List Details Success': props<{ details: DiscoverListAndLinksDetailsVM }>(),
    'Load Discover List Details Failure': props<{ error: HttpErrorResponse }>(),
    'Load Multi Order Strategies Success': props<{ strategies: MultiOrderStrategy[] }>(),
    'Load Multi Order Strategies Failure': props<{ error: HttpErrorResponse }>(),
    'Load Multi Order Strategy Success': props<{ strategy: MultiOrderStrategyDetails }>(),
    'Load Multi Order Strategy Failure': props<{ error: HttpErrorResponse }>(),
    'Load Multi Order Strategy Assets Success': props<{ assets: Asset[] }>(),
    'Load Multi Order Strategy Assets Failure': props<{ error: HttpErrorResponse }>(),
  },
});
